import * as $runtime from "../runtime.js";
import * as Control$dMonad$dExcept$dTrans from "../Control.Monad.Except.Trans/index.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dCodec from "../Data.Codec/index.js";
import * as Data$dCodec$dJSON from "../Data.Codec.JSON/index.js";
import * as Data$dCodec$dJSON$dSum from "../Data.Codec.JSON.Sum/index.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dList$dNonEmpty from "../Data.List.NonEmpty/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dSet from "../Data.Set/index.js";
import * as Data$dSet$dNonEmpty from "../Data.Set.NonEmpty/index.js";
import * as Data$dTraversable from "../Data.Traversable/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Data$dUnfoldable from "../Data.Unfoldable/index.js";
import * as Foreign$dObject from "../Foreign.Object/index.js";
import * as JSON$dInternal from "../JSON.Internal/index.js";
import * as JSON$dObject from "../JSON.Object/index.js";
import * as JSON$dPath from "../JSON.Path/index.js";
const apply = /* #__PURE__ */ (() => Data$dCodec.applyCodec(Control$dMonad$dExcept$dTrans.applyExceptT(Data$dIdentity.monadIdentity))(Data$dList$dTypes.semigroupList).apply)();
const fromFoldable = /* #__PURE__ */ Data$dMap$dInternal.fromFoldable(Data$dOrd.ordString)(Data$dFoldable.foldableArray);
const applicativeExceptT = /* #__PURE__ */ Control$dMonad$dExcept$dTrans.applicativeExceptT(Data$dIdentity.monadIdentity);
const traverse = /* #__PURE__ */ (() => Data$dTraversable.traversableArray.traverse(applicativeExceptT))();
const toUnfoldable = /* #__PURE__ */ (() => {
  const $0 = Data$dUnfoldable.unfoldableArray.unfoldr(xs => {
    if (xs.tag === "Nil") { return Data$dMaybe.Nothing; }
    if (xs.tag === "Cons") { return Data$dMaybe.$Maybe("Just", Data$dTuple.$Tuple(xs._1, xs._2)); }
    $runtime.fail();
  });
  return x => $0((() => {
    const go = (m$p, z$p) => {
      if (m$p.tag === "Leaf") { return z$p; }
      if (m$p.tag === "Node") { return go(m$p._5, Data$dList$dTypes.$List("Cons", m$p._3, go(m$p._6, z$p))); }
      $runtime.fail();
    };
    return go(x, Data$dList$dTypes.Nil);
  })());
})();
const fromFoldable4 = /* #__PURE__ */ Data$dList$dNonEmpty.fromFoldable(Data$dFoldable.foldableArray);
const toUnfoldable1 = /* #__PURE__ */ (() => {
  const $0 = Data$dUnfoldable.unfoldableArray.unfoldr(Data$dMap$dInternal.stepUnfoldr);
  return x => $0(Data$dMap$dInternal.$MapIter("IterNode", x, Data$dMap$dInternal.IterLeaf));
})();
const fromFoldable7 = /* #__PURE__ */ Data$dFoldable.foldrArray(Data$dList$dTypes.Cons)(Data$dList$dTypes.Nil);
const tuple = codecA => codecB => {
  const $0 = Data$dCodec$dJSON.indexedArray(apply((() => {
    const $0 = Data$dCodec$dJSON.index(0)(codecA);
    return Data$dCodec.$Codec(
      x => {
        const $1 = $0._1(x);
        if ($1.tag === "Left") { return Data$dEither.$Either("Left", $1._1); }
        if ($1.tag === "Right") { return Data$dEither.$Either("Right", Data$dTuple.Tuple($1._1)); }
        $runtime.fail();
      },
      x => {
        const $1 = $0._2(x._1);
        return Data$dTuple.$Tuple($1._1, Data$dTuple.Tuple($1._2));
      }
    );
  })())((() => {
    const $0 = Data$dCodec$dJSON.index(1)(codecB);
    return Data$dCodec.$Codec(
      x => {
        const $1 = $0._1(x);
        if ($1.tag === "Left") { return Data$dEither.$Either("Left", $1._1); }
        if ($1.tag === "Right") { return Data$dEither.$Either("Right", $1._1); }
        $runtime.fail();
      },
      x => {
        const $1 = $0._2(x._2);
        return Data$dTuple.$Tuple($1._1, $1._2);
      }
    );
  })()));
  return Data$dCodec.$Codec(
    j => {
      const v = $0._1(j);
      if (v.tag === "Left") { return Data$dEither.$Either("Left", {path: v._1.path, message: "Could not decode Tuple", causes: [v._1]}); }
      return v;
    },
    b => Data$dTuple.$Tuple($0._2(b)._1, b)
  );
};
const strMap = codec => {
  const $0 = Control$dMonad$dExcept$dTrans.bindExceptT(Data$dIdentity.monadIdentity);
  const $1 = traverse(Data$dTraversable.traversableTuple.traverse(applicativeExceptT)(codec._1));
  const go = v => {
    if (v.tag === "Leaf") { return Data$dMap$dInternal.Leaf; }
    if (v.tag === "Node") { return Data$dMap$dInternal.$$$Map("Node", v._1, v._2, v._3, codec._2(v._4)._1, go(v._5), go(v._6)); }
    $runtime.fail();
  };
  return Data$dCodec.$Codec(
    a => $0.bind(Data$dCodec$dJSON.jobject._1(a))(x => {
      const $2 = $1(JSON$dInternal._entries(Data$dTuple.Tuple, x));
      if ($2.tag === "Left") { return Data$dEither.$Either("Left", $2._1); }
      if ($2.tag === "Right") { return Data$dEither.$Either("Right", fromFoldable($2._1)); }
      $runtime.fail();
    }),
    b => Data$dTuple.$Tuple(Data$dCodec$dJSON.jobject._2(JSON$dObject.fromFoldableWithIndex(Data$dMap$dInternal.foldableWithIndexMap)(go(b)))._1, b)
  );
};
const $$set = dictOrd => {
  const fromFoldable8 = Data$dFoldable.foldlArray(m => a => Data$dMap$dInternal.insert(dictOrd)(a)()(m))(Data$dMap$dInternal.Leaf);
  return codec => {
    const $0 = Data$dCodec$dJSON.array(codec);
    return Data$dCodec.$Codec(
      x => {
        const v = $0._1(x);
        if (v.tag === "Left") { return Data$dEither.$Either("Left", {path: v._1.path, message: "Could not decode Set", causes: [v._1]}); }
        if (v.tag === "Left") { return Data$dEither.$Either("Left", v._1); }
        if (v.tag === "Right") { return Data$dEither.$Either("Right", fromFoldable8(v._1)); }
        $runtime.fail();
      },
      x => {
        const $1 = Data$dArray.fromFoldableImpl(Data$dSet.foldableSet.foldr, x);
        return Data$dTuple.$Tuple($0._2($1)._1, fromFoldable8($1));
      }
    );
  };
};
const nonEmptyString = /* #__PURE__ */ Data$dCodec.$Codec(
  j => {
    const v = Data$dCodec$dJSON.string._1(j);
    if (v.tag === "Left") { return Data$dEither.$Either("Left", {path: v._1.path, message: "Could not decode NonEmptyString", causes: [v._1]}); }
    if (v.tag === "Right") {
      if (v._1 === "") { return Data$dEither.$Either("Left", {path: JSON$dPath.Tip, message: "Could not decode NonEmptyString, unexpected value found", causes: []}); }
      return Data$dEither.$Either("Right", v._1);
    }
    $runtime.fail();
  },
  b => Data$dTuple.$Tuple(Data$dCodec$dJSON.string._2(b)._1, b)
);
const nonEmptySet = dictOrd => {
  const fromFoldable8 = Data$dSet$dNonEmpty.fromFoldable(Data$dFoldable.foldableArray)(dictOrd);
  return codec => {
    const $0 = Data$dCodec$dJSON.array(codec);
    return Data$dCodec.$Codec(
      j => {
        const v = $0._1(j);
        if (v.tag === "Left") { return Data$dEither.$Either("Left", {path: v._1.path, message: "Could not decode NonEmptySet", causes: [v._1]}); }
        if (v.tag === "Right") {
          const v1 = fromFoldable8(v._1);
          if (v1.tag === "Just") { return Data$dEither.$Either("Right", v1._1); }
          if (v1.tag === "Nothing") { return Data$dEither.$Either("Left", {path: JSON$dPath.Tip, message: "Could not decode NonEmptySet, unexpected value found", causes: []}); }
        }
        $runtime.fail();
      },
      b => Data$dTuple.$Tuple($0._2(toUnfoldable(b))._1, b)
    );
  };
};
const nonEmptyList = codec => {
  const $0 = Data$dCodec$dJSON.array(codec);
  return Data$dCodec.$Codec(
    j => {
      const v = $0._1(j);
      if (v.tag === "Left") { return Data$dEither.$Either("Left", {path: v._1.path, message: "Could not decode NonEmptyList", causes: [v._1]}); }
      if (v.tag === "Right") {
        const v1 = fromFoldable4(v._1);
        if (v1.tag === "Just") { return Data$dEither.$Either("Right", v1._1); }
        if (v1.tag === "Nothing") { return Data$dEither.$Either("Left", {path: JSON$dPath.Tip, message: "Could not decode NonEmptyList, unexpected value found", causes: []}); }
      }
      $runtime.fail();
    },
    b => Data$dTuple.$Tuple($0._2(Data$dArray.fromFoldableImpl(Data$dList$dTypes.foldableNonEmptyList.foldr, b))._1, b)
  );
};
const nonEmptyArray = codec => {
  const $0 = Data$dCodec$dJSON.array(codec);
  return Data$dCodec.$Codec(
    j => {
      const v = $0._1(j);
      if (v.tag === "Left") { return Data$dEither.$Either("Left", {path: v._1.path, message: "Could not decode NonEmptyArray", causes: [v._1]}); }
      if (v.tag === "Right") {
        if (v._1.length > 0) { return Data$dEither.$Either("Right", v._1); }
        return Data$dEither.$Either("Left", {path: JSON$dPath.Tip, message: "Could not decode NonEmptyArray, unexpected value found", causes: []});
      }
      $runtime.fail();
    },
    b => Data$dTuple.$Tuple($0._2(b)._1, b)
  );
};
const maybe = codec => Data$dCodec$dJSON$dSum.taggedSum("Maybe")(v => {
  if (!v) { return "Nothing"; }
  if (v) { return "Just"; }
  $runtime.fail();
})(v => {
  if (v === "Nothing") { return Data$dMaybe.$Maybe("Just", false); }
  if (v === "Just") { return Data$dMaybe.$Maybe("Just", true); }
  return Data$dMaybe.Nothing;
})(v => {
  if (!v) { return Data$dEither.$Either("Left", Data$dMaybe.Nothing); }
  if (v) {
    return Data$dEither.$Either(
      "Right",
      x => {
        const $0 = codec._1(x);
        if ($0.tag === "Left") { return Data$dEither.$Either("Left", $0._1); }
        if ($0.tag === "Right") { return Data$dEither.$Either("Right", Data$dMaybe.$Maybe("Just", $0._1)); }
        $runtime.fail();
      }
    );
  }
  $runtime.fail();
})(v => {
  if (v.tag === "Nothing") { return Data$dTuple.$Tuple(false, Data$dMaybe.Nothing); }
  if (v.tag === "Just") { return Data$dTuple.$Tuple(true, Data$dMaybe.$Maybe("Just", codec._2(v._1)._1)); }
  $runtime.fail();
});
const map = dictOrd => {
  const fromFoldable8 = Data$dMap$dInternal.fromFoldable(dictOrd)(Data$dFoldable.foldableArray);
  return codecA => codecB => {
    const $0 = Data$dCodec$dJSON.array(tuple(codecA)(codecB));
    return Data$dCodec.$Codec(
      x => {
        const v = $0._1(x);
        if (v.tag === "Left") { return Data$dEither.$Either("Left", {path: v._1.path, message: "Could not decode Map", causes: [v._1]}); }
        if (v.tag === "Left") { return Data$dEither.$Either("Left", v._1); }
        if (v.tag === "Right") { return Data$dEither.$Either("Right", fromFoldable8(v._1)); }
        $runtime.fail();
      },
      x => {
        const $1 = toUnfoldable1(x);
        return Data$dTuple.$Tuple($0._2($1)._1, fromFoldable8($1));
      }
    );
  };
};
const list = codec => {
  const $0 = Data$dCodec$dJSON.array(codec);
  return Data$dCodec.$Codec(
    x => {
      const v = $0._1(x);
      if (v.tag === "Left") { return Data$dEither.$Either("Left", {path: v._1.path, message: "Could not decode List", causes: [v._1]}); }
      if (v.tag === "Left") { return Data$dEither.$Either("Left", v._1); }
      if (v.tag === "Right") { return Data$dEither.$Either("Right", fromFoldable7(v._1)); }
      $runtime.fail();
    },
    x => {
      const $1 = Data$dArray.fromFoldableImpl(Data$dList$dTypes.foldableList.foldr, x);
      return Data$dTuple.$Tuple($0._2($1)._1, fromFoldable7($1));
    }
  );
};
const foreignObject = /* #__PURE__ */ (() => {
  const $0 = Foreign$dObject.toUnfoldable(Data$dUnfoldable.unfoldableArray);
  const $1 = Foreign$dObject.fromFoldable(Data$dFoldable.foldableArray);
  return x => {
    const $2 = Data$dCodec$dJSON.array(tuple(Data$dCodec$dJSON.string)(x));
    return Data$dCodec.$Codec(
      x$1 => {
        const $3 = $2._1(x$1);
        if ($3.tag === "Left") { return Data$dEither.$Either("Left", $3._1); }
        if ($3.tag === "Right") { return Data$dEither.$Either("Right", $1($3._1)); }
        $runtime.fail();
      },
      x$1 => {
        const $3 = $2._2($0(x$1));
        return Data$dTuple.$Tuple($3._1, $1($3._2));
      }
    );
  };
})();
const either = codecA => codecB => Data$dCodec$dJSON$dSum.taggedSum("Either")(v => {
  if (v) { return "Left"; }
  return "Right";
})(v => {
  if (v === "Left") { return Data$dMaybe.$Maybe("Just", true); }
  if (v === "Right") { return Data$dMaybe.$Maybe("Just", false); }
  return Data$dMaybe.Nothing;
})(v => {
  if (v) {
    return Data$dEither.$Either(
      "Right",
      x => {
        const $0 = codecA._1(x);
        if ($0.tag === "Left") { return Data$dEither.$Either("Left", $0._1); }
        if ($0.tag === "Right") { return Data$dEither.$Either("Right", Data$dEither.$Either("Left", $0._1)); }
        $runtime.fail();
      }
    );
  }
  return Data$dEither.$Either(
    "Right",
    x => {
      const $0 = codecB._1(x);
      if ($0.tag === "Left") { return Data$dEither.$Either("Left", $0._1); }
      if ($0.tag === "Right") { return Data$dEither.$Either("Right", Data$dEither.$Either("Right", $0._1)); }
      $runtime.fail();
    }
  );
})(v => {
  if (v.tag === "Left") { return Data$dTuple.$Tuple(true, Data$dMaybe.$Maybe("Just", codecA._2(v._1)._1)); }
  if (v.tag === "Right") { return Data$dTuple.$Tuple(false, Data$dMaybe.$Maybe("Just", codecB._2(v._1)._1)); }
  $runtime.fail();
});
export {
  applicativeExceptT,
  apply,
  either,
  foreignObject,
  fromFoldable,
  fromFoldable4,
  fromFoldable7,
  list,
  map,
  maybe,
  nonEmptyArray,
  nonEmptyList,
  nonEmptySet,
  nonEmptyString,
  $$set as set,
  strMap,
  toUnfoldable,
  toUnfoldable1,
  traverse,
  tuple
};
